module.exports = __webpack_public_path__ + "img/premium-slider-3.b498566f.png";